var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-control"},[_c('label',{staticClass:"label"},[_c('span',{staticClass:"label-text"},[_vm._v(_vm._s(_vm.label))])]),_c('multi-select',{attrs:{"value":_vm.value,"options":_vm.options},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }